export const buildPubSubTopic = (...parts: string[]): string => parts.join('.');

export const parsePubSubTopic = (topic: string): string[] => topic.split('.');
